module.exports = __webpack_public_path__ + "img/creative.ead5539c.png";